export function useApi() {
  async function apiFetch(path, options = {}) {
    const { headers: customHeaders, ...restOptions } = options;
    const res = await fetch(path, {
      credentials: 'same-origin',
      ...restOptions,
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders,
      },
    });

    if (res.status === 401) {
      window.location.href = '/login';
      return null;
    }

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || `Request failed: ${res.status}`);
    }

    return res.json();
  }

  return { apiFetch };
}
